import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable()
export class WafErrorInterceptor implements HttpInterceptor {
  private injector = inject(Injector);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const contentType = event.headers.get('Content-Type');

          if (contentType?.includes('text/html')) {
            this.handleHtmlBody(event.body);
          }
        }

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const contentType = error.headers?.get('Content-Type');

        if (contentType?.includes('text/html')) {
          if (error.error && typeof error.error.text === 'string') {
            this.handleHtmlBody(error.error.text);
          } else {
            this.handleHtmlBody(error.error);
          }
        }

        return throwError(() => error);
      })
    );
  }

  private handleHtmlBody(body: unknown): void {
    if (body instanceof ArrayBuffer) {
      const decoder = new TextDecoder('utf-8');
      const message = decoder.decode(body);
      this.checkForWafMessage(message);
    } else if (body instanceof Blob) {
      body
        .text()
        .then((message) => this.checkForWafMessage(message))
        .catch((error) => console.error(`Fehler beim Lesen der WAF-Fehlermeldung: ${error}`));
    } else if (typeof body === 'string') {
      this.checkForWafMessage(body);
    }
  }

  private checkForWafMessage(messageText: string): void {
    if (!messageText) {
      return;
    }

    if (messageText.includes('The requested URL was rejected.') && messageText.includes('Your support ID is:')) {
      console.error('WAF Error erkannt:', messageText);

      const translate = this.injector.get(TranslateService);
      const msgService = this.injector.get(MessageService);

      const supportIdMatch = messageText.match(/Your support ID is:\s*(\d+)/);
      const supportId = supportIdMatch ? supportIdMatch[1] : 'unbekannt';
      const message: ToastMessageOptions = {
        severity: 'error',
        summary: translate.instant('common.error'),
        detail: translate.instant('shared.waf-error', { supportId }),
        sticky: true
      };

      msgService.add(message);
    }
  }
}
